var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPro1F4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 43L42 51L26 50L22 53L17 48L21.29 43.71L26 39H40V43L42 45L54.94 39.82L57 39L58 43Z",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43H32",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 53L25 56L22 59L10 47L13 44L17 48",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 59L18 63L6 51L10 47",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49 18C49 27.3888 41.3888 35 32 35C22.6112 35 15 27.3888 15 18C15 8.61116 22.6112 1 32 1C41.3888 1 49 8.61116 49 18Z",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41 36.979C44.5913 35.2755 47.6254 32.5877 49.7497 29.2281C51.8739 25.8684 53.001 21.9749 53 18",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18C10.9994 21.9745 12.1267 25.8676 14.2509 29.2269C16.3751 32.5862 19.409 35.2736 23 36.977",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.135 41C48.3205 38.7912 51.8237 35.4818 54.267 31.4287C56.7103 27.3757 58.001 22.7326 58 18",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18C5.99917 22.7328 7.29018 27.376 9.73385 31.4291C12.1775 35.4822 15.6811 38.7914 19.867 41",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M45 18C45 25.1797 39.1797 31 32 31C24.8203 31 19 25.1797 19 18C19 10.8203 24.8203 5 32 5C39.1797 5 45 10.8203 45 18Z",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27 13H32C32.7956 13 33.5587 13.3161 34.1213 13.8787C34.6839 14.4413 35 15.2044 35 16C35 16.7956 34.6839 17.5587 34.1213 18.1213C33.5587 18.6839 32.7956 19 32 19H28L34 25",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28 13H37",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27 16H37",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32 5V1",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32 35V31",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45 18H49",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18H19",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1919 27.1919L44.0209 30.0209",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.979 5.979L22.808 8.808",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1919 8.808L44.0209 5.979",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.979 30.0209L22.808 27.1919",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#006257"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPro1F4);
export default __webpack_public_path__ + "static/media/pro-1-f-4.aa50a716bcbff5fe713920731f35c7fa.svg";
export { ForwardRef as ReactComponent };